import { render, staticRenderFns } from "./ConversationActionsSendCredits.vue?vue&type=template&id=5d3141d6&"
import script from "./ConversationActionsSendCredits.vue?vue&type=script&lang=js&"
export * from "./ConversationActionsSendCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports